import { v4 as generateID } from '@lukeed/uuid';
import omit from 'lodash/omit';
import { DatumKind } from '../../../constants/SignalsKinds';
export function getDiaIDs(range) {
    return [].concat(range.diaIDs || [], range.signals
        ? range.signals.flatMap((_signal) => _signal.diaIDs || [])
        : []);
}
export function getNbAtoms(range, signalIndex) {
    if (signalIndex === undefined) {
        let sum = 0;
        if (range.signals) {
            for (const signal of range.signals) {
                sum += signal.nbAtoms || 0;
            }
        }
        return sum;
    }
    return range.signals[signalIndex].nbAtoms || 0;
}
export function setNbAtoms(range, signalIndex) {
    range.nbAtoms = getNbAtoms(range, signalIndex);
    if (range.nbAtoms === 0) {
        delete range.nbAtoms;
    }
}
export function resetDiaIDs(range) {
    const deletedKeys = ['diaIDs', 'nbAtoms'];
    range = omit(range, deletedKeys);
    range.signals = range.signals.map((signal) => {
        return omit(signal, deletedKeys);
    });
}
export function unlink(range, options = {}) {
    const { unlinkType = 'both', signalIndex = -1 } = options;
    const keys = ['diaIDs', 'nbAtoms'];
    switch (unlinkType) {
        case 'both':
            resetDiaIDs(range);
            break;
        case 'range':
            range = omit(range, keys);
            break;
        case 'signal':
            if (signalIndex !== -1) {
                range.signals[signalIndex] = omit(range.signals[signalIndex], keys);
            }
            break;
        default:
            break;
    }
    return range;
}
export function addDefaultSignal(range) {
    range.signals.push({
        id: generateID(),
        multiplicity: 'm',
        kind: 'signal',
        js: [],
        delta: (range.to + range.from) / 2,
    });
}
export function checkRangeKind(range) {
    return range.kind === DatumKind.signal;
}
export function checkSignalKinds(range, kinds) {
    return !range.signals.some((_signal) => _signal.kind === undefined || !kinds.includes(_signal.kind));
}
//# sourceMappingURL=RangeUtilities.js.map